export const typeformId = {
	interestForm: "ga3yvrCX",
	feedback: "iskygKFv",
};
